import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button, EmptyState } from "@/shared/ui";

/** Full-screen 404 — the router's default `notFoundComponent`. */
export function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="grid min-h-screen place-items-center bg-canvas">
      <EmptyState
        title={t("errors.notFoundMessage")}
        action={
          <Button variant="ghost" onClick={() => void navigate({ to: "/" })}>
            {t("errors.goHome")}
          </Button>
        }
      />
    </div>
  );
}
